import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import LiveQueryResource from "cc-frontend/helpers/live-query"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Element: any
  Args: {
    group: Group
    currentSchoolYearId: string
  }
}

export default class GroupTeamForTeamlessMembers extends Component<Signature> {
  @use planbooksQuery = new LiveQueryResource(() => {
    return [
      "planbooks_for_members_not_in_teams_for_school_year",
      `${this.args.group.id}:${this.args.currentSchoolYearId}`,
    ]
  })
  @use membersQuery = new LiveQueryResource(() => ["members_not_in_teams", this.args.group.id])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::TeamForTeamlessMembers": typeof GroupTeamForTeamlessMembers
  }
}
